import { DataTable } from "primereact/datatable";
import { useEffect, useState, Suspense, useRef } from "react";
import { ColumnDef } from "../../models/orders/order-list-model";
import { Column } from "primereact/column";
import AppLoading from '../app-loading/app-loading';  
import orderServices from "../../services/orders/orderservice";
import { Toast } from 'primereact/toast';

interface DataTableProps {
  dateFilter: any;
}

const CashDataTable: React.FC<DataTableProps> = (dataList) => {
  const [orderDataList, setOrderDataList] = useState<any>();
  const [loading, setLoading] = useState(false);
  const toast = useRef<Toast>(null);

  useEffect(() => {
    setLoading(true);
    orderServices.cashandOnlineList(dataList).then((response:any) => {
    if(response.length > 0){
               setOrderDataList(response.collectionList);
               setLoading(false)
            }
            else{
               setOrderDataList(response.collectionList);
               setLoading(false)
            }
        });
  },[dataList]);


  const columns: ColumnDef[] = [
    {
      field: "orderID",
      header: "Order #",
      style: { minWidth: "5rem" },
      sortable:true,
    },
    {
      field: "invoiceNo",
      header: "Invoice #",
      style: { minWidth: "5rem" },
      sortable:true,
    },
    {
      field: "invoiceDate",
      header: "Invoice Date",
      style: { minWidth: "9rem" },
      sortable:true,
      cell: (row: any) =>
      new Date(row.invoiceDate).toLocaleDateString("en-gb", {
          day: "2-digit",
          month: "short",
          year: "numeric",
      }),
    },
    {
      field: "invoiceBy",
      header: "Invoice By",
      style: { minWidth: "9rem" },
      sortable:true,
    },
    {
      field: "courierCharges",
      header: "Courier Charges",
      style: { minWidth: "5rem" },
      sortable:true,
      cell: (row: any) =>
        Math.round(row.courierCharges).toLocaleString("en-gb", {
          style: "currency",
          currency: "INR",
        }),
    },
    {
      field: "handlingCharges",
      header: "Handling Charges",
      style: { minWidth: "5rem" },
      sortable:true,
      cell: (row: any) =>
        Math.round(row.handlingCharges).toLocaleString("en-gb", {
          style: "currency",
          currency: "INR",
        }),
    },
    {
      field: "paymentGatewayCharges",
      header: "PaymentGateway Charges",
      style: { minWidth: "5rem" },
      sortable:true,
      cell: (row: any) =>
        Math.round(row.paymentGatewayCharges).toLocaleString("en-gb", {
          style: "currency",
          currency: "INR",
        }),
    },
    {
      field: "discountAmount",
      header: "Discount Amount",
      style: { minWidth: "5rem" },
      sortable:true,
      cell: (row: any) =>
        Math.round(row.discountAmount).toLocaleString("en-gb", {
          style: "currency",
          currency: "INR",
        }),
    },
    {
      field: "grossAmount",
      header: "Gross Amount",
      style: { minWidth: "5rem" },
      sortable:true,
      cell: (row: any) =>
        Math.round(row.grossAmount).toLocaleString("en-gb", {
          style: "currency",
          currency: "INR",
        }),
    },
  ];


  return (
    <>
      <Suspense fallback={<AppLoading />}>
        <Toast ref={toast} />
          <div className="col-12 card border-noround p-2">
            <DataTable
                value={orderDataList}
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                stripedRows
                showGridlines
                sortMode="multiple"
                emptyMessage="No Record found."
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
              >
              {columns.map((col, i) => (
                <Column
                  key={i}
                  field={col.field}
                  header={col.header}
                  sortable={col.sortable}
                  style={col.style}
                  body={col.cell}
                />
              ))}
            </DataTable>
          </div>
        {loading && <AppLoading />}
      </Suspense>
    </>
  );
};

export default CashDataTable;